
import { cancellive, refusedtolive } from '@/api';
import router from '@/router';
import { useI18n } from '@/utils/i18n';
import { defineComponent, ref, toRaw, watch } from "vue";

export default defineComponent({
    props: {
        info: Array,
        livestatus: Number,
        zid:Number
    },
    setup(props) {
        const lan: any = useI18n();
        const modalNode = () => document.getElementsByClassName('modal-container')[0]
        const updatePhoneVisible = ref(false)
        const sid = ref(0)
        const list = ref<any>(props.info);
        const text = ref("")

        watch(()=> props.info,()=>{
            // console.log(props.info)
            list.value = props.info
        })
        async function quxiao(index: number){
            console.log(index, list.value[index]);
            sid.value = index;
            updatePhoneVisible.value = true;
            // const res = await cancellive(list.value[index].memberid, 3);
            // if(res){
            //     list.value[index].status = 3
            // }
        }
        function hidePhoneModal(): void {
            updatePhoneVisible.value = false;
            text.value = "";
        }
        async function sum(){
            console.log(sid.value, text.value)
            const res = await refusedtolive(list.value[sid.value].signupid, text.value);
            if(res){
                list.value[sid.value].status = 3;
                hidePhoneModal();
            }
        }
        function toxq(){
            router.push({path:"/regime/studentlist",query:{liveid:props.zid}})
            console.log(props.zid,"aaa")
        }

        
        return {
            list,
            quxiao,
            modalNode,
            updatePhoneVisible,
            hidePhoneModal,
            sum,
            text,
            toxq,
            lan
        };
    },
});
